module.exports = __webpack_public_path__ + "78980f1756e40d1173bf57ccef2df46b.png";